export const LOCALE = 'pt-PT';
export const CURRENCY = 'EUR';

export function formatCurrency(value) {
  const num = Number(value) || 0;
  return new Intl.NumberFormat(LOCALE, { style: 'currency', currency: CURRENCY }).format(num);
}

export function formatNumber(value, options = {}) {
  const num = Number(value) || 0;
  return new Intl.NumberFormat(LOCALE, options).format(num);
}

export function formatDate(dateInput, options = {}) {
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  const defaultOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
  return new Intl.DateTimeFormat(LOCALE, { ...defaultOptions, ...options }).format(date);
}